/**
 * JS calculate loan
 */

/**
 * Calculate loan
 *
 * @param params
 */
const calculateLoan = ( params: paramsCalculateLoan ) => {
	const dataMonths = [];
	let totalInterest = 0;
	const interestRatePerMonth = params.interestRate / 12 / 100;
	const originPerMonth = params.amountBorrow / params.duration;

	if ( params.type === 1 ) {
		let debt = params.amountBorrow;

		const interestPerMonth = params.amountBorrow * interestRatePerMonth;
		totalInterest = interestPerMonth * params.duration;

		for ( let i = 0; i < params.duration + 1; i++ ) {
			const dataMonth = {
				month: 0,
				debt: 0,
				originPay: 0,
				interestPay: 0,
				all: 0,
			};

			if ( i == params.duration ) {
				dataMonth.originPay = originPerMonth;
				dataMonth.interestPay = interestPerMonth;
				dataMonth.all = originPerMonth + interestPerMonth;
			} else if ( i > 0 ) {
				dataMonth.debt = debt;
				dataMonth.originPay = originPerMonth;
				dataMonth.interestPay = interestPerMonth;
				dataMonth.all = originPerMonth + interestPerMonth;
			} else {
				dataMonth.debt = params.amountBorrow;
				dataMonth.originPay = '';
				dataMonth.interestPay = '';
				dataMonth.all = '';
			}

			debt -= originPerMonth;
			dataMonths.push( dataMonth );
		}
	} else {
		let debt = params.amountBorrow;

		for ( let i = 0; i < params.duration + 1; i++ ) {
			const dataMonth = {
				month: 0,
				debt: 0,
				originPay: 0,
				interestPay: 0,
				all: 0,
			};

			let interestOfMonth = 0;
			if ( i > 0 ) {
				interestOfMonth = ( params.amountBorrow - ( originPerMonth * ( i - 1 ) ) ) * interestRatePerMonth;
			}

			dataMonth.month = i;

			if ( i == params.duration ) {
				dataMonth.originPay = originPerMonth;
				dataMonth.interestPay = interestOfMonth;
				dataMonth.all = originPerMonth + interestOfMonth;
			} else if ( i > 0 ) {
				dataMonth.debt = debt;
				dataMonth.originPay = originPerMonth;
				dataMonth.interestPay = interestOfMonth;
				dataMonth.all = originPerMonth + interestOfMonth;
			} else {
				dataMonth.debt = params.amountBorrow;
				dataMonth.originPay = '';
				dataMonth.interestPay = '';
				dataMonth.all = '';
			}

			debt -= originPerMonth;
			totalInterest += interestOfMonth;
			dataMonths.push( dataMonth );
		}
	}

	if ( isNaN( params.amountBorrow ) ) {
		params.amountBorrow = 0;
	}

	const totalAll = params.amountBorrow + totalInterest;
	const data = {
		totalInterest,
		totalAll,
		amountBorrow: params.amountBorrow,
		dataMonths,
	};

	displayLoan( data );
};

const formatNumber = ( value: string ) => {
	const options = {
		style: 'decimal',
		useGrouping: true, // Add thousands separator
		minimumFractionDigits: 0, // Show whole numbers only
		maximumFractionDigits: 2, // Specify the maximum number of decimal places
	};

	return Number( Number( value ).toFixed( 0 ) ).toLocaleString( 'en-US', options );
};

const displayLoan = ( data: any ) => {
	const elPageRoot = document.querySelector( '.page-bepos-calculate-loan' );
	if ( ! elPageRoot ) {
		return;
	}

	const elLoanDetail = elPageRoot.querySelector( '.bepos_calculate_loan_detail' );
	const elTable = elLoanDetail.querySelector( 'table' );
	const tbodyTable = elTable.querySelector( 'tbody' );
	const elTotalInterest = elPageRoot.querySelector( '.total_interest' );
	const elTotalAll = elPageRoot.querySelector( '.total_all' );

	elTotalInterest.textContent = formatNumber( data.totalInterest );
	elTotalAll.textContent = formatNumber( data.totalAll );

	// Add list
	tbodyTable.innerHTML = '';
	data.dataMonths.forEach( ( value, key ) => {
		const elNew = document.createElement( 'tr' );
		elNew.innerHTML = `
			<td class="stt">${ key }</td>
			<td class="debt">${ formatNumber( value.debt ) }</td>
			<td class="originPay">${ value.originPay > 0 ? formatNumber( value.originPay ) : '' }</td>
			<td class="interestPay">${ value.interestPay > 0 ? formatNumber( value.interestPay ) : '' }</td>
			<td class="totalAllOnMonth">${ value.all > 0 ? formatNumber( value.all ) : '' }</td>
		`;

		tbodyTable.appendChild( elNew );
	} );

	// Row total price.
	const elNewRowTotalPrice = document.createElement( 'tr' );
	elNewRowTotalPrice.classList.add( 'total-price' );
	elNewRowTotalPrice.innerHTML = `
			<td class="">Tổng Tiền</td>
			<td class=""></td>
			<td class="total-originPay">
				<div>
					<span class="price">${ formatNumber( data.amountBorrow ) }</span>
					<span class="currency">VNĐ</span>
				</div>
			</td>
			<td class="total-interestPay">
				<div>
					<span class="price">${ formatNumber( data.totalInterest ) }</span>
					<span class="currency">VNĐ</span>
				</div>
			</td>
			<td class="totalAll">
				<div>
					<span class="price">${ formatNumber( data.totalAll ) }</span>
					<span class="currency">VNĐ</span>
					</div>
			</td>
		`;
	tbodyTable.appendChild( elNewRowTotalPrice );

	elTable.style.display = 'table';
};

type paramsCalculateLoan = {
	amountBorrow: number,
	interestRate: number, // % per Year
	duration: number,
	type: number, // 1 For origin const, 2 for origin down
}

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	let params: paramsCalculateLoan;
	params = {
		amountBorrow: 0,
		interestRate: 0,
		duration: 0,
		type: 1,
	};

	const form = document.querySelector( '#bepos-form-calculate-loan' );
	if ( ! form ) {
		return;
	}

	const elAmountBorrow = form.querySelector( '[name=bepos_amountBorrow]' );
	elAmountBorrow.addEventListener( 'input', ( e ) => {
		const el = e.target;
		let value = el.value.replace( /,/g, '' );
		if ( value === '' ) {
			value = 0;
		}

		value = parseInt( value );
		if ( isNaN( value ) ) {
			value = 0;
		}

		el.value = formatNumber( value );
	} );

	form.addEventListener( 'submit', ( e ) => {
		e.preventDefault();

		for ( const input of form.elements ) {
			const nameField = input.name.replace( 'bepos_', '' );
			if ( params.hasOwnProperty( nameField ) ) {
				let value = input.value;
				if ( nameField === 'amountBorrow' ) {
					value = value.replace( /,/g, '' );
				}
				params[ nameField ] = parseFloat( value );
			}

			if ( isNaN( params.interestRate ) ) {
				params.interestRate = 0;
			}
		}

		calculateLoan( params );
	} );
} );
